module.exports = __webpack_public_path__ + "img/teams.1328a208.png";